import { get, post } from "./index";

export const standardizedGet = async (url: string) => {
  const { result, isError, errorTable } = await get(url);
  if (isError) {
    throw new Error(errorTable);
  }
  return result;
};

export const standardizedPost = async <T>(url: string, body: T) => {
  const { result, isError, errorTable } = await post(url, body);
  if (isError) {
    throw new Error(errorTable);
  }
  return result;
};
